import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { App } from './app/app';
import './index.scss';
import { ToastContainer } from 'react-toastify';
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsxs(_Fragment, { children: [_jsx(ToastContainer, { position: "top-center", hideProgressBar: true, closeButton: false, autoClose: 2000, draggable: 'touch', style: {
                top: '16px',
            } }), _jsx(App, {})] }));
